import P from "components/P";

import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { forwardRef, useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addCommas } from "shared/utils/Utils";
import style from "./OrderProducttRow.module.css";
import InputNumber from "components/inputs/signUp/InputNumber";

const OrderProducttRow = forwardRef((props, ref) => {
    const { isMobile } = useContext(BrowserDetectContext);
    const { data, quantity } = props;
    const { t } = useTranslation();
    const inputs = useRef([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { products } = useSelector((state) => ({
        products: state.orderInfo.products,
    }));

    useEffect(() => {
        if(data){
            
            
        }
    },[data])


    const onProductClick = () => {
        // navigate(`/product/detail/${data.product.id}`);
    }

    const onQuantityChange = (value) => {
        // let changedList = products.map((orderProduct) => {
        //     let changedOrderProduct = clone(orderProduct);
        //     if (changedOrderProduct.product.id === data.product.id) {
        //         changedOrderProduct.quantity = value;
        //     }
        //     return changedOrderProduct;
        // });
        // dispatch(OrderInfoReducer.actions.refreshOrderProducts(changedList));

    }

    const callback = (index, state) => {
        if (props.callback) {
            props.callback(index, state);
        }
    }

    return (
        <div className={style.productWrap}>
            {
                isMobile ?
                    <HorizontalFlex gap={10}>
                        <FlexChild width={"20%"} >
                            <div className={style.imgWrap} >
                                <img src={data &&data.productImg} className={style.img} />
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex>
                                <FlexChild>
                                    <div className={style.contentWrap}>
                                        <p className={style.title} onClick={onProductClick} >{data &&data.productName}</p>
                                    </div>
                                </FlexChild>
                                <FlexChild alignItems={"flex-end"}>
                                    {
                                        data &&
                                        <P color={"#c4c4c4"} weight={"500"} size={14} verticalAlign={"bottom"} textDecoration={"line-through"}>
                                            &#8361;{addCommas(data && quantity ? data.price * quantity : data.price * data.quantity)}
                                        </P>
                                    }
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap={5}>
                                        <FlexChild width={"60%"}>
                                            {
                                                props.readOnly ?
                                                    <PaddingWrapper padding={"0px 10px"}>
                                                        <P>{`${t("orderQuantity")} : ${data && quantity ? quantity : data.quantity}`}</P>
                                                    </PaddingWrapper>

                                                    : <InputNumber ref={el => (inputs.current[0] = el)} min={1} height={30} value={data && quantity ? quantity : data.quantity} onChange={onQuantityChange} />
                                            }

                                        </FlexChild>
                                        <FlexChild width={"max-content"} justifyContent={"flex-end"}>
                                            <P color={"var(--main-color)"} weight={"800"} size={15} verticalAlign={"bottom"}>
                                                &#8361;{addCommas(data && quantity ? data.price * quantity : data.price * data.quantity)}
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                    :
                    <HorizontalFlex gap={10}>
                        <FlexChild width={70} >
                            <div className={style.imgWrap} >
                                <img src={data && data.productImg} className={style.img} />
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <div className={style.contentWrap}>
                                <p className={style.title} onClick={onProductClick} >{data && data.productName}</p>
                            </div>
                        </FlexChild>
                        <FlexChild width={150}>
                            {
                                props.readOnly ?
                                    <Center>
                                        <P>{data && quantity ? quantity : data.quantity}</P>
                                    </Center>

                                    : <InputNumber ref={el => (inputs.current[0] = el)} min={1} height={30} value={data && quantity ? quantity : data.quantity} onChange={onQuantityChange} />
                            }

                        </FlexChild>
                        <FlexChild width={120}>
                            <VerticalFlex>
                                {/* <FlexChild>
                                    {
                                        data.product.currentPrice &&
                                        <P color={"#c4c4c4"} weight={"500"} size={15} verticalAlign={"bottom"} textDecoration={"line-through"}>
                                            &#8361;{addCommas(data && data.price * data.quantity)}
                                        </P>
                                    }
                                </FlexChild> */}
                                <FlexChild>
                                    <P color={"var(--main-color)"} weight={"800"} size={15} verticalAlign={"bottom"}>
                                        &#8361;{addCommas(data && quantity ? data.price * quantity : data.price * data.quantity)}
                                    </P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </HorizontalFlex>
            }
        </div>
    );
});

export default OrderProducttRow;

